import { HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { CBox_PublicPaginatedResponse } from "@server/services/cbox/public/api/v1/resources/common/request_base/types";
import { CBox_GetZoneListResponseItem } from "@server/services/cbox/public/api/v1/resources/zone/types";
import { firstValueFrom } from "rxjs";
import { ApiService } from "../api/api.service";

@Injectable({ providedIn: "root" })
export class ZonesService {

  private api = inject(ApiService);

  async getList(): Promise<CBox_GetZoneListResponseItem[]> {
    const params = new HttpParams({
      fromObject: { page: 1, pageSize: 1000 },
    });
    const response = await firstValueFrom(
      this.api.get<CBox_PublicPaginatedResponse<CBox_GetZoneListResponseItem>>(
        "backend/zones", params));

    return response.data;
  }
}
